import { AfterViewInit, Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'craft-hubspot-form',
  template: '',
  styleUrls: ['./hubspot-form.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HubSpotFormComponent implements AfterViewInit {
  @Input() public hubspotFormId: string;
  @Input() public hubspotPortalId: string;

  constructor() {}

  @HostBinding('id')
  public get id(): string {
    return `hubspotform-${this.hubspotFormId}`;
  }

  public ngAfterViewInit(): void {
    const hubspot = (window as any).hbspt;
    if (!hubspot) return;

    hubspot.forms.create({
      target: `#${this.id}`,
      formId: this.hubspotFormId,
      portalId: this.hubspotPortalId,
    });
  }
}
